/// FOURJS_START_COPYRIGHT(D,2025)
/// Property of Four Js*
/// (c) Copyright Four Js 2025, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT
"use strict";

modulum("ButtonTagEditWidget", ["ButtonEditWidget", "WidgetFactory"], function (context, cls) {
  /**
   * @class ButtonTagEditWidget
   * @memberOf classes
   * @extends classes.ButtonEditWidget
   */
  cls.ButtonTagEditWidget = context.oo.Class(cls.ButtonEditWidget, function ($super) {
    /** @lends classes.ButtonTagEditWidget.prototype */
    return {
      __name: "ButtonTagEditWidget",
      __templateName: "ButtonEditWidget",

      /**
       * @inheritDoc
       */
      _initElement: function () {
        this.setEditWidgetName("TagEdit");
        $super._initElement.call(this);
      },

      /**
       * Control whether the current input is proposed as a new tag in the completer
       * If false, the "(+)" option will not be shown in the dropdown
       * @param {boolean} value
       */
      setAllowTagCreation: function (value) {
        this._edit.setAllowTagCreation(value);
      }
    };
  });
  // Register the widget with WidgetFactory
  cls.WidgetFactory.registerBuilder("ButtonEdit[customWidget=tagEdit]", cls.ButtonTagEditWidget);
  cls.WidgetFactory.registerBuilder("ButtonTagEdit", cls.ButtonTagEditWidget);
});
